import { ensureInteger, ensureString } from '@/mixins/useEnsure'
import BrowserService from '@/services/browserService'

export default (user, cart, eventName) => {
  if (cart && cart.cartProducts) {
    const products = cart.cartProducts.map((item) => {
      return {
        id: ensureString(item.productID),
        name: item.name,
        favorite: false,
        categories: item.categories.map((c) => {
          return c.title
        }),
        labels: item.properties.map((p) => {
          return p.name
        }),
        availability: 'stock',
        price: Number(item.priceWithoutVat),
        currency: item.currencyCode,
        discount: 0,
        quantity: item.quantity,
      }
    })

    const mixes = cart.cartMixes.map((item) => {
      return {
        id: ensureString(item.mixID),
        name: item.name,
        favorite: item.isFavorite,
        categories: [item.kind],
        labels: [],
        availability: 'stock',
        price: Number(item.priceWithoutVat),
        currency: item.currencyCode,
        discount: 0,
        quantity: item.quantity,
      }
    })

    const items = [...products, ...mixes]

    let discount = null
    if (cart?.discountItems?.length) {
      discount = cart?.discountItems[0]
    }

    const payload = {
      event: eventName,
      platform: BrowserService.platform(),
      sessionId: BrowserService.sessionId(),
      currency: cart.currencyCode,
      value: Number(cart.productPriceWithoutVat),
      payment: Number(cart.totalPrice),
      tax: Number(cart.totalVat),
      shipping: cart.selectedTransport ? Number(cart.selectedTransport.priceWithoutVat) : 0,
      sale: discount?.discountType,
      coupon: discount?.discountCode,
      discount: discount ? Number(discount?.totalPrice) * ensureInteger(discount?.quantity) : 0,
      credits: Number(cart.credits),
      payment_type: cart.selectedPayment?.name,
      shipping_type: cart.selectedTransport?.name,
      ecommerce: {
        currency: cart.currencyCode,
        products: items,
        user: user,
      },
      _clear: true,
    }
    window.dataLayer?.push(payload)
  }
}
